import React from 'react';
import S from '../../styles/components';

class ListItem extends React.PureComponent {
  handleClick = () => {
    const { value, onClick } = this.props;
    onClick(value);
  };

  render() {
    const { icon, title, badge, extra, value, selected } = this.props;
    return (
      <S.ListItem>
        {false && (
          <S.ListItemExtra>
            <S.ListCheckbox
              key={selected}
              checked={selected}
              onClick={this.handleClick}
            />
          </S.ListItemExtra>
        )}
        <S.ListItemContent>
          <S.ListItemTitle>
            {icon} {title}
          </S.ListItemTitle>
          {badge !== undefined && (
            <S.ListItemBadge>
              {badge}
            </S.ListItemBadge>
          )}
        </S.ListItemContent>
      </S.ListItem>
    );
  }
}

export default ListItem;
